/**
 * Conditional logging utility for development vs production environments.
 * In production, only error logs are displayed.
 */

const isDev = import.meta.env.DEV;

export const logger = {
  /**
   * Log informational messages - only in development
   */
  log: (...args: unknown[]): void => {
    if (isDev) {
      console.log(...args);
    }
  },

  /**
   * Log warning messages - only in development
   */
  warn: (...args: unknown[]): void => {
    if (isDev) {
      console.warn(...args);
    }
  },

  /**
   * Log error messages - always logged (critical for debugging)
   */
  error: (...args: unknown[]): void => {
    console.error(...args);
  },

  /**
   * Log debug messages with [DEBUG] prefix - only in development
   */
  debug: (...args: unknown[]): void => {
    if (isDev) {
      console.log('[DEBUG]', ...args);
    }
  },

  /**
   * Log informational messages with custom prefix - only in development
   */
  info: (prefix: string, ...args: unknown[]): void => {
    if (isDev) {
      console.log(`[${prefix}]`, ...args);
    }
  },
};
